











































































import { mapActions } from 'vuex';

import { ALForm } from '@/common/component.types';
import {
  IQuoteDocumentData,
  IQuotePackageDocument,
  IQuotePackageDocumentData,
  QuotePackageDocument
} from '@/models';
import { FieldErrors, SystemError } from '@/models/error/error';
import { ISystemError, ISystemErrorData } from '@/models/error/error.types';

import mixins from '@/utils/mixins';
import authMixin from '@/mixins/auth';
import formRulesMixin from '@/mixins/file-upload-rules';

import ALDialog from '../core/Dialog/ALDialog.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import DragDropFileInput from '../common/DragDropFileInput.vue';

const baseMixins = mixins(authMixin, formRulesMixin);

export interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    form: ALForm;
  };
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    name: 'QuoteDocumentPackageFileUploadDialog',
    components: {
      ALDialog,
      DragDropFileInput,
      ErrorAlert
    },

    data() {
      return {
        dialog: false,
        loading: false,
        isEdit: false,

        isFormValid: false,

        documentPackageData: {
          quote_document: { document: {} } as IQuoteDocumentData
        } as IQuotePackageDocumentData,

        error: null as ISystemError | null
      };
    },

    methods: {
      ...mapActions({
        createQuoteProjectDocument: 'quote/createQuoteProjectDocument'
      }),

      resetFormValidation(): void {
        if (this.$refs.form) {
          return this.$refs.form.resetValidation();
        }
      },

      validateForm(): boolean {
        let valid = false;
        if (this.$refs.form) {
          valid = this.$refs.form.validate();
        }
        return valid;
      },

      open(quotePackageDocument: IQuotePackageDocumentData) {
        this.clearErrors();
        this.resetFormValidation();

        this.documentPackageData = {
          ...quotePackageDocument,
          quote_document: { document: {} } as IQuoteDocumentData
        } as IQuotePackageDocumentData;

        this.dialog = true;
      },

      close() {
        this.dialog = false;
      },

      save() {
        this.clearErrors();
        const valid = this.validateForm();

        let quoteDocumentInstance: IQuotePackageDocument | null = null;

        if (valid) {
          try {
            quoteDocumentInstance = new QuotePackageDocument(
              this.documentPackageData
            );
          } catch (error) {
            if (SystemError.isSystemError(error)) {
              this.error = error;
            }
          }

          if (quoteDocumentInstance != null) {
            this.loading = true;

            this.createQuoteProjectDocument(quoteDocumentInstance)
              .then(data => {
                this.$emit('document-uploaded', data);
                this.close();
              })
              .catch(error => {
                const systemErrorData: ISystemErrorData = {
                  name: error.name,
                  message: error.message
                };

                if (error.response) {
                  // The request was made and the server responded with a status code
                  // that falls out of the range of 2xx
                  systemErrorData.message = error.response.statusText;
                  if (error.response.data.detail) {
                    systemErrorData.detail = error.response.data.detail;
                  } else if (FieldErrors.isFieldError(error.response.data)) {
                    systemErrorData.fieldErrors = new FieldErrors(
                      error.response.data
                    );
                  }
                } else if (error.request) {
                  // The request was made but no response was received (Can happen on 500 error)
                  systemErrorData.detail =
                    'There was an error in processing your request. Please check with IT Admin';
                }

                this.error = new SystemError(systemErrorData);
              })
              .finally(() => {
                this.loading = false;
              });
          }
        }
      },

      clearErrors() {
        this.error = null;
      }
    }
  });
